import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateServicesHero(section, img, textLines, hr) {

  // Individual Tweens 
  // Image 
  let imgTween = img ? gsap.to(img, {
    duration: 0.8,
    opacity: 1,
    ease: "power1.in",
  }) : null;

  // Animated lines of text
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Animated hr 
  let hrTween = hr ? gsap.to(hr, {
    width: "100%",
    duration: 0.4,
    opacity: 1
  }) : null;

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 90%",
    },
  });

  tl
    .add(imgTween)
    .addLabel("textStart")
    .add(textLinesTween, "textStart-=0.4")
    .add(hrTween, "textStart");
}